import React from 'react';
import { createPortal } from 'react-dom';
import { Button } from 'rebass/styled-components';

import BriefPdfDocument from 'features/briefs/components/molecules/BriefPdfDocument';
import { useBriefPdfPrint } from 'features/briefs/hooks/useBriefPdfPrint';

import { BRIEF_COPY } from 'shared/config/copy';
import { Brief } from 'shared/typings/briefs';

interface Props {
  brief: Brief;
  variant?: string;
  className?: string;
  /** Injected by Dropdown to close the menu once an option is picked. */
  onClick?: () => void;
}

/**
 * Exports the brief as a PDF by printing a print-only copy of the full brief.
 * The document is rendered into a portal so it sits outside the app shell, which
 * the print stylesheet hides.
 */
const ExportBriefPdfButton: React.FC<Props> = ({ brief, variant, className, onClick }) => {
  const { isPrinting, exportPdf } = useBriefPdfPrint(brief);

  const handleClick = () => {
    exportPdf();
    if (onClick) onClick();
  };

  return (
    <>
      <Button onClick={handleClick} variant={variant} className={className} data-cy="export-brief-pdf-button">
        {BRIEF_COPY.BUTTON_EXPORT_PDF}
      </Button>
      {isPrinting && createPortal(<BriefPdfDocument brief={brief} />, document.body)}
    </>
  );
};

export default ExportBriefPdfButton;
